import { Button } from 'antd';
import React from 'react';
import * as XLSX from "xlsx"

function ExportToExel({report,meters, parameters ,filename}) {
  console.log( report,meters)
  console.log(meters)
  const finalReport = []
  report?.filter(re => {
    const date = re.date
    const data = {date}
    meters?.forEach(meter => {
      if(re[meter]){
        data[meter] = re[meter]
      }
    })
    finalReport.push(data)
  })
  const exportTo = () => {
    const wb = XLSX.utils.book_new()
    const ws = XLSX.utils.json_to_sheet(finalReport)

    XLSX.utils.book_append_sheet(wb, ws, `${filename}`)
    XLSX.writeFile(wb, `${filename}.xlsx`)
    // XLSX.utils.book_append_sheet(wb, ws, "raw_data_report")
    // XLSX.writeFile(wb, "raw_data_report.xlsx")
  }

  return (
    <div>
      <Button variant="contained" defaultColor='green' onClick={exportTo}>
        Export to Exel
      </Button>
    </div>
  );
}

export default ExportToExel;